module.exports = __webpack_public_path__ + "img/title-bg.3428027a.png";